// extracted by mini-css-extract-plugin
module.exports = {"rosreestr-label":"dd31006766--rosreestr-label--hBwTt"};